<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content *ngIf="!toShowTemplate">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Product name</mat-label>
        <input
          readonly
          [maxlength]="30"
          [(ngModel)]="productListData.product_name"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          readonly
          [(ngModel)]="productListData.product_desc"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>HSN code</mat-label>
        <input
          [(ngModel)]="productListData.hsn_code"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div style="margin-bottom: 15px;">

            
        
<!--         
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop"></mat-checkbox>
            <mat-label>Shop service</mat-label>
            
         
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome"></mat-checkbox>
            <mat-label>Home service</mat-label>
                        
            <mat-checkbox value="virtual" (change)="change($event)" ></mat-checkbox>
            <mat-label>Virtual service</mat-label> -->

               
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop" *ngIf="shop_status != '2'"></mat-checkbox>
            <mat-label *ngIf="shop_status != '2'">Shop service</mat-label>
            
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome" *ngIf="home_status != '2'"></mat-checkbox>
            <mat-label *ngIf="home_status != '2'">Home service</mat-label>
            
            <mat-checkbox value="virtual" (change)="change($event)" [checked]="isVirtual" *ngIf="virtual_status != '2'"></mat-checkbox>
            <mat-label *ngIf="virtual_status != '2'">Virtual service</mat-label>
            
        
    </div>
    
    <div *ngIf="isShopSpecific == true">
        <mat-form-field appearance="outline">
          <mat-label>Shop rate</mat-label>
          <input  smDecimalOnly  type="number"
          [(ngModel)]="productListData.shop_price"
          matInput
        
        />
         
        </mat-form-field>
    </div>
    <div *ngIf="isHomeSpecific == true">
      <mat-form-field appearance="outline">
        <mat-label>Home rate</mat-label>
        <input  smDecimalOnly  type="number"
        [(ngModel)]="productListData.home_price"
        matInput
      
      />
        
      </mat-form-field>
</div>
  <div *ngIf="isVirtualSpecific == true">
    <mat-form-field appearance="outline">
      <mat-label>Virtual rate</mat-label>
      <input 
      [(ngModel)]="productListData.virtual_price"
       smDecimalOnly  type="number"
      matInput
    
    />
      
    </mat-form-field>
</div>
<div>
    <mat-form-field appearance="outline">
      <mat-label>Manufacturer</mat-label>
      <input
        [(ngModel)]="productListData.manufacturer"
        matInput
        #input
      />
     
    </mat-form-field>
  </div>
  <!-- <div>
    <mat-form-field appearance="outline">
      <mat-label>Quantity info</mat-label>
      <input
        smDecimalOnly  type="number"
        [(ngModel)]="productListData.qty_info"
        matInput
        #input
      />
     
    </mat-form-field>
  </div> -->
 <p style="margin-bottom: 20px;">Selling quantity info: <br><strong>{{productListData.qty_info}} {{productListData.selling_unit}}</strong> </p>
    <div style="margin-bottom: 10px;">
        <mat-label>Enable Discount</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChange($event)" [checked]="isDiscountApplicable"></mat-slide-toggle>
        <br><br>
<!-- 
        <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div *ngIf="productListData.discount_status == '1'" style="margin-bottom: 10px;">
        <mat-label>Discount type</mat-label>
        <br><br>

        <input type="radio" id="percent" name="discountType" [checked]="isPercent == true" value="percent" (click)="discType($event)">
        <label for="percent" class="radlabel">Percent</label>
        <input type="radio" id="amount" name="discountType" [checked]="isAmount == true" value="amount" (click)="discType($event)">
        <label for="amount" class="radlabel">Amount</label>

    </div>
    <div *ngIf="productListData.discount_status == '1'">
        <mat-form-field appearance="outline">
          <mat-label>Discount Amount</mat-label>
          <input smDecimalOnly  type="number" 
            [(ngModel)]="productListData.discount"
            matInput
  
          />
         
        </mat-form-field>
      </div>
      <div style="margin-bottom: 10px;">
        <mat-label>Enable tax</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChangeForTax($event)" [checked]="isTaxApplicable"></mat-slide-toggle>
      <br><br>
        <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
      <!-- [(value)]="selectedView" [(ngModel)]="selectedView" (ngModelChange)="changeView()" -->
       <div *ngIf="isTaxApplicable && taxSlabData.length > 0">
        <mat-form-field appearance="outline">
           <mat-select [(value)]="selectedSlab" [(ngModel)]="selectedSlab" class="w-100">
                       <mat-option value="default" >
                         Select a tax
                       </mat-option>
                       <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                         {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                       </mat-option>
                      
                     </mat-select>
        </mat-form-field>
       </div>
       <div *ngIf="isTaxApplicable && taxSlabData.length == 0">
        <p>Tax not configured yet. <a href="javascript:void(0)" (click)="configureTax()">Click to configure</a></p>
       </div>
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="toShowTemplate">
    <div class="row" *ngIf="inventoryItems.length>0 && !loader">
        <div class="col-sm-4" *ngFor="let item of inventoryItems">
            <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                <div class="top_section_order">
                    <div class="row">
                       
                                <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                </div>
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                    <img [src]="item.image_thumb_url">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec" style="position: relative;">
                             
                                <h3>{{item.item_name}}</h3>
                                <p class="elips_cls">{{
                                  item.item_desc
                                }}
                                </p>
                                <p style="margin-top: 5px;">{{item.selling_quantity}} {{item.selling_unit}}
                                </p>
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <!-- <p style="margin-top: 10px;">Quantity info: {{item.quantity_info}} 
                                </p> -->
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                       <div class="addmore_btn" *ngIf="item.selected">
                        <button mat-flat-button color="accent" (click)="onSelectNext()"><mat-icon>add</mat-icon>  Add this </button>
                    </div>
                </div>
            </div>
        </div>
        

        <div *ngIf="datalength > inventoryItems.length" style="text-align: center;">
          <button
          style="
          width: 50%;
          border-radius: 50px;
      "
      mat-flat-button
      color="accent"
      (click)="seeMore()"
    >
      See more
    </button>
   
        </div>
        

    </div>
     <div class="row" *ngIf="inventoryItems.length==0 && !loader" style="text-align: center;    padding-top: 50px;
    padding-bottom: 50px;">
      <div class="product_svgh">
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M131.756 352.381v149.064c-2.728 0-5.455-.641-7.967-1.923L17.569 445.37C11.407 442.231 7.5 435.73 7.5 428.618V300.389c0-3.586.993-7.015 2.769-9.942l121.487 61.934zM210.462 463.462 256 440.253V289.04l-124.241 63.342v149.06c2.721 0 5.455-.641 7.959-1.923l38.882-19.817" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#434343" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" opacity="1" class=""></path><path d="m256 289.04-124.241 63.342-121.495-61.939c1.681-2.758 4.064-5.08 6.967-6.628l114.529-61.552L256 289.04zM380.244 352.381v149.064c2.728 0 5.455-.641 7.967-1.923l106.22-54.151c6.162-3.139 10.069-9.64 10.069-16.752v-128.23c0-3.586-.993-7.015-2.768-9.942l-121.488 61.934zM380.241 352.382v149.06c-2.721 0-5.455-.641-7.959-1.923L256 440.253V289.04l124.241 63.342z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#434343" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" opacity="1" class=""></path><path d="M316.1 256.737 256 289.04l124.241 63.342 121.495-61.939c-1.681-2.758-4.064-5.08-6.967-6.628l-50.38-27.076M256 138.273V289.04l-124.241-66.777-.003-135.977c0-3.586.993-7.015 2.768-9.941L256 138.273zM256 289.04V138.273l121.47-61.928a19.167 19.167 0 0 1 2.768 9.941l.001 27.396M377.47 76.344 256 138.273 134.524 76.344c1.682-2.763 4.059-5.08 6.961-6.634l106.204-57.055c.029-.012.053-.03.082-.042a17.473 17.473 0 0 1 16.534.042L370.509 69.71c2.902 1.555 5.285 3.871 6.961 6.634z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#434343" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" opacity="1" class=""></path><path d="M433.996 173.149c-13.313-14.562-32.466-23.696-53.752-23.696-40.212 0-72.81 32.598-72.81 72.81s32.598 72.81 72.81 72.81 72.81-32.598 72.81-72.81c0-6.178-.769-12.176-2.218-17.904" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#434343" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" opacity="1" class=""></path><path d="m346.089 225.329 24.257 22.476 42.759-44.952" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#434343" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" opacity="1" class=""></path></g></svg>
      </div>
      <div class="product_placeholder_heading">
        <h3 style="color:#333">No item to select here.</h3>
        <p style="color:#888">To add a product for selling you need to add that first in your inventory. Go to Inventory section and add one.</p>
        </div>

    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowTemplate">
    <button mat-button (click)="back()">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !productListData.product_name ||
        !productListData.product_desc ||
        priceCheker() ||
        discountChecker()
      "
      (click)="onPost()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>


  <!-- <mat-dialog-actions align="end" *ngIf="toShowTemplate">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedProductList.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Next
    </button>
  </mat-dialog-actions> -->
  